import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectDealsList } from '../../features/dealsList/dealsListSlice';
import { setGlobalLoading, selectGlobalLoading } from '../../appSlice';
import { selectFilterData } from '../../features/mainFilter/selectors';
import { selectLocationDealsList } from '../../features/locationDeals/locationDealsSlice';
import { scrollToResultsFast, showFavoriteButton, hideTwigSkeletons, isMobile } from '../../utilities/helpers';

export default function useGlobalLoading() {
  const dispatch = useDispatch();
  const [isFirstUpdate, setIsFirstUpdate] = useState(true);

  const mainFilter = useSelector(selectFilterData);
  const dealsList = useSelector(selectDealsList);
  const globalLoading = useSelector(selectGlobalLoading);
  const { showResults } = useSelector((state) => state.app);
  const { pending: mainFilterPending, error: mainFilterError } = mainFilter;
  const { list: locationDeals } = useSelector(selectLocationDealsList);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'instant',
    });
  };

  const loadingWithoutOffers = () => {
    scrollToTop();
    const skeleton = document.querySelector('.skeleton-without-offers');
    setTimeout(() => {
      if (skeleton) {
        showFavoriteButton();
        skeleton.classList?.add('hide-skeleton');
        scrollToTop();
      }
    }, 600);
    if (!mainFilterPending && !mainFilterError && globalLoading.heroSectionLoading) {
      setIsFirstUpdate(false);
      setTimeout(() => {
        dispatch(setGlobalLoading({ ...globalLoading, heroSectionLoading: false }));
      }, 600);
      setTimeout((globalLoading) => {
        dispatch(
          setGlobalLoading({
            ...globalLoading,
            heroSectionLoading: false,
            hintsBlockLoading: false,
          })
        );
      }, 900);
    }
  };

  const loadingWithOffers = () => {
    if ((dealsList?.dealsList?.length > 0 || locationDeals?.length > 0 || (dealsList && !dealsList?.dealsList?.length && !locationDeals?.length && !dealsList.pending)) && isFirstUpdate) {
      const skeleton = document.querySelector('.skeleton-with-offers');
      if (isMobile()) {
        scrollToResultsFast();
      }
      setIsFirstUpdate(false);
      setTimeout(() => {
        showFavoriteButton();
        if (skeleton) {
          skeleton.classList?.add('hide-skeleton');
        }
        if (isMobile()) {
          scrollToResultsFast();
        }
      }, 600);
      dispatch(setGlobalLoading({ heroSectionLoading: false, secondaryFilterLoading: true, dealListLoading: true }));
      setTimeout(() => {
        dispatch(
          setGlobalLoading({
            heroSectionLoading: false,
            secondaryFilterLoading: false,
            dealListLoading: true,
          })
        );
      }, 1200);
      setTimeout(() => {
        dispatch(
          setGlobalLoading({
            heroSectionLoading: false,
            secondaryFilterLoading: false,
            dealListLoading: false,
          })
        );
      }, 1600);
    }
  };

  useEffect(() => {
    if (!(window.pr_welcome && window.innerWidth <= 768)) {
      hideTwigSkeletons(3000);
    }
  }, []);

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (showResults) {
        //const skeleton = document.querySelector('.skeleton-with-offers');
        //skeleton.classList?.remove('hide-skeleton');
        //scrollToResultsFast();
      } else {
        //const skeleton = document.querySelector('.skeleton-without-offers');
        //skeleton.classList?.remove('hide-skeleton');
        scrollToTop();
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [showResults]);

  useEffect(() => {
    if (showResults) {
      loadingWithOffers();
    } else if (!showResults && isFirstUpdate) {
      loadingWithoutOffers();
    }
  }, [dispatch, dealsList, isFirstUpdate, mainFilter]);

  useEffect(() => {
    if (window.pr_welcome === true) {
      document.dispatchEvent(new CustomEvent('pr_welcome_appReady', {}));
    }
  }, []);
}
